export const headless = /HeadlessChrome/.test(window.navigator.userAgent);
